import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { Table } from "antd";
import DatePicker from "react-datepicker";
// import Accordion from 'react-bootstrap/Accordion';
import Select from "react-select";
import * as Yup from "yup";
// import { adminMainUrl } from '../../Config';
import Offcanvas from "react-bootstrap/Offcanvas";
// import { adminMainUrl } from '../../../../Config';
const EditMaster = ({ show, handleClose, onSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const closeButtonRef = useRef(null);
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    code: Yup.string().required("Code is required"),
    short_name: Yup.string().required("Short Name is required"),
    applicabl_for: Yup.string().required("Applicable for is required"),
    charge_category: Yup.string().required("Charge Category is required"),
    IATA_code: Yup.string().required("IATA Code is required"),
    vendor: Yup.string().required("Vendor is required"),
    desc: Yup.string().required("Description is required"),
    valid_till: Yup.string().required("Valid Till is required"),
    valid_from: Yup.string().required("Valid From is required"),
    contract_date: Yup.string().required("Contract Date is required"),
    contract_no: Yup.string().required("Contract Date is required"),
    ref_date : Yup.string().required("Ref. Date  is required"),
    trade : Yup.string().required("Trade Lane is required"),
    notes : Yup.string().required("Notes is required"),
    date : Yup.string().required("Date is required"),
    cal_Method : Yup.string().required("Cal. Method is required"),
    rate : Yup.string().required("Rate is required"),
    port : Yup.string().required("Port is required"),
    charge_head : Yup.string().required("Charge Head is required"),
    // name: Yup.string().required('Code is required'),
  });

  const [startDate, setStartDate] = useState(new Date());

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      name: "", // Initial value for the RequiredService type
      code: "",
      short_name: "",
      applicabl_for: "",
      charge_category: "",
      IATA_code: "",
      name: "",
      vendor: "",
      desc: "",
      valid_till: "",
      valid_from: "",
      contract_date: "",
      contract_no: "",
      ref_date: "",
      trade: "",
      notes: "",
      date: "",
      cal_Method: "",
      rate: "",
      port: "",
      charge_head: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      handleClose();
      formik.resetForm();
      setIsSubmitting(true);
      // try {
      //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
      //         method: 'POST',
      //         headers: {
      //             'Content-Type': 'application/json',
      //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
      //         },
      //         body: JSON.stringify(values),
      //     });

      //     const data = await response.json();

      //     if (response.ok) {
      //         // closeButtonRef.current.click();
      //         if (onSuccess) onSuccess();
      //         toast.success(data?.msg);
      //         handleClose()
      //         formik.resetForm();
      //     } else {
      //         toast.error(data?.msg);
      //         // Handle errors from the server
      //         console.error('Error creating RequiredService Type:', data.message);
      //     }
      // } catch (error) {
      //     console.error('Network error:', error);
      // }
      // finally {
      //     setIsSubmitting(false); // Stop the spinner
      // }
    },
  });
  const [editshow, setEditShow] = useState(false);
  const handleEditClose = () => setEditShow(false);
  const handleEditShow = () => setEditShow(true);
  const columns1 = [
    { title: "S. No.", dataIndex: "SNo", key: "SNo" },
    { title: "Code", dataIndex: "Code", key: "Code" },
    { title: "Name", dataIndex: "Name", key: "Name" },
    { title: "Action", dataIndex: "action", key: "action" },
  ];

  const dataSource1 = [
    {
      key: "1", // Add a unique key for each row
      SNo: "1", // Changed to camelCase
      Name: "",
      Code: "",
      action: (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <div className="dropdown-item cursor-pointer" to="#">
              <i className="fas fa-trash text-blue me-2"></i> Delete
            </div>
          </div>
        </div>
      ),
    },
  ];

  const ApplicableOption = [
    { value: "aizobel", label: "Aizobel / INAZ" },
    { value: "bagdogra", label: "Bagdogra / INBD" },
    { value: "akola", label: "Akola / INAL" },
    { value: "amritsar", label: "Amritsar / INAR" },
  ];
  const NameOption = [
    { value: "Port", label: "Port" },
    { value: "Country", label: "Country" },
  ];

  return (
    <Offcanvas className="" show={show} onHide={handleClose} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Edit Currencies</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <form onSubmit={formik.handleSubmit}>
        <div className="col-12">
            <div className="mb-3">
              <div className="card">
                <div className="card-header">General</div>
                <div className="card-body">
                  <div className="row mb-3">
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Code <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Major Unit <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Minor Unit <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Scale <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Symbol <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Round To <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Minimum <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  </div>
                  <div className="d-flex justify-content-end gap-2 mt-2">
            {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
            <button
              className="btn btn-primary text-xs"
              type="submit"
              onClick={handleClose}
            >
              Submit
            </button>
            <button className="btn btn-primary text-xs" type="submit">
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & New
                        </button>
                        <button className="btn btn-light text-xs" type="submit" onClick={handleClose}>
                            Close
                        </button>
          </div>
                </div>
              </div>
            </div>
            
          </div>
        <div className="col-12">
            <div className="mb-3">
              <div className="card">
                <div className="card-header">Custom Clearing</div>
                <div className="card-body">
                  <div className="row mb-3">
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  EDI Code <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Code For B/E <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Is Standard <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  No of Units <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="name"
                  name="name"
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="error">{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
                  </div>
                  <div className="d-flex justify-content-end gap-2 mt-2">
            {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
            <button
              className="btn btn-primary text-xs"
              type="submit"
              onClick={handleClose}
            >
              Submit
            </button>
            <button className="btn btn-primary text-xs" type="submit">
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & New
                        </button>
                        <button className="btn btn-light text-xs" type="submit" onClick={handleClose}>
                            Close
                        </button>
          </div>
                </div>
              </div>
            </div>
            
          </div>
          
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EditMaster;
